/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shared_UpdateChildcareRequest = {
    addressId?: string;
    canton?: shared_UpdateChildcareRequest.canton;
    logo_url?: string;
    name?: string;
    /**
     * Phone is the public phone number of this location, shown to parents as a
     * "call the daycare" button in the parent app; trimmed, "" clears it.
     */
    phone?: string;
    status: shared_UpdateChildcareRequest.status;
};
export namespace shared_UpdateChildcareRequest {
    export enum canton {
        AG = 'AG',
        AI = 'AI',
        AR = 'AR',
        BE = 'BE',
        BL = 'BL',
        BS = 'BS',
        FR = 'FR',
        GE = 'GE',
        GL = 'GL',
        GR = 'GR',
        JU = 'JU',
        LU = 'LU',
        NE = 'NE',
        NW = 'NW',
        OW = 'OW',
        SG = 'SG',
        SH = 'SH',
        SO = 'SO',
        SZ = 'SZ',
        TG = 'TG',
        TI = 'TI',
        UR = 'UR',
        VD = 'VD',
        VS = 'VS',
        ZG = 'ZG',
        ZH = 'ZH',
    }
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
}

